module.exports = {
  domain: {
    desktop: "www.prd.use2.racing.fndlext.net",
    mobile: "www.prd.use2.racing.fndlext.net",
    talentPicks: "www.prd.use2.racing.fndlext.net/talent-picks/",
    accountWallet: "account.racing.fanduel.com",
    equibase: "equibase-store.tvg.com"
  },
  recaptchaID: "6LdrNBgqAAAAAKKs_ZP23RQvTYPkSFdZQ9KK_j6K",
  recaptchaIdNative: "6LfSQloqAAAAAFKuurdHLnObQ-r2CGo0TuuYdNq-"
};
